import { ReactNode } from "react";

interface MarkerHighlightProps {
  children: ReactNode;
  /** Altura de la banda relativa al tamaño de fuente */
  height?: string;
  className?: string;
}

/**
 * Trazo de rotulador amarillo "hecho a mano": banda maciza detrás del texto,
 * anclada a la base y con una rotación mínima. Mismo estilo que "apagando fuegos".
 */
const MarkerHighlight = ({
  children,
  height = "0.45em",
  className = "",
}: MarkerHighlightProps) => (
  <span className={`relative inline-block ${className}`}>
    <span
      aria-hidden
      className="absolute inset-x-[-0.14em] bottom-[0.06em] -rotate-[0.6deg] rounded-xs bg-[#FFE143]"
      style={{ height }}
    />
    <span className="relative">{children}</span>
  </span>
);

export default MarkerHighlight;
